import { Injectable } from '@angular/core';
import { FactoryhelperService } from '../../../shared/services/factoryHelper.service';
import { AgAppConfigService } from '@ag/vc.ag-core/settings';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PersonDetails } from '../../../shared/models/PersonDetailsModel';
import { EditAdress } from '../../../shared/models/edit-adress';
import { AgTranslateService } from '@ag/vc.ag-core/translate';
import { createUserReqObj, createUserResponse } from '../../../shared/models/IdentityModel';

@Injectable({
  providedIn: 'root'
})
export class UserIdentificationService {

  isIdentitySaved = false;
  isIdentityEdited = false;
  isPhoneNumberEdited = false;
  isEmailEdited = false;
  private cityValidity = false;
  private zipcodeValidity = false;
  private countryValidity = false;
  private apiUrl: string;


  constructor(
    private readonly factoryhelperService: FactoryhelperService,
    private readonly translateService: AgTranslateService
  ) {
    this.apiUrl = AgAppConfigService.get<string>('applicativeApiUrl');
  }
 
  setZipCodeValidity(validity: boolean): void {
    this.zipcodeValidity = validity;
  }

  setCityValidity(validity: boolean): void {
    this.cityValidity = validity;
  }
  setCountryValidity(validity: boolean): void {
    this.countryValidity = validity;
  }

  
  getPersonalAddressFormValidity(): boolean {
    return this.cityValidity && this.zipcodeValidity && this.countryValidity;
  }
 
  getPersonDetails(personId) {
    const culture = this.translateService.currentLang;
    const url = `${this.apiUrl}/${culture}/manageuser/retrievepersondetails/personid/${personId}`;
    return this.factoryhelperService.get(url);
  }

  savePersonDetailsForm(data: Partial<PersonDetails> | EditAdress): Observable<boolean> {
    const culture = this.translateService.currentLang;
    const url = `${this.apiUrl}/${culture}/manageuser/updatepersondata`;
    return this.factoryhelperService.post<{ Result: boolean }>(url, data).pipe(map(x => x.Result));
  }
  getzipCodeCountryDetails(): Observable<unknown> {
    const culture = this.translateService.currentLang;
    const url = `${this.apiUrl}/${culture}/silcommon/getzipcodesandcountry`;
    return this.factoryhelperService.get(url);
  }
  getCityDetails(zipcode: string | number): Observable<unknown> {
    const culture = this.translateService.currentLang;
    const url = `${this.apiUrl}/${culture}/silcommon/getcity/${zipcode}`;
    return this.factoryhelperService.get(url);
  }
   
  CheckPersonalDetails(productCodeRange: number): Observable<{IsPersonAgeAllowed : boolean, IsPersonCountryAllowed : boolean}> {
    const culture = this.translateService.currentLang;
    const url = `${this.apiUrl}/${culture}/manageuser/checkpersonaldetails/personid/${localStorage.personId}/product/${productCodeRange}`;
    return this.factoryhelperService.get<{ Result: {IsPersonAgeAllowed : boolean, IsPersonCountryAllowed : boolean}}>(url).pipe(map(x => x.Result));
  }  

  createUser(reqObj: createUserReqObj): Observable<createUserResponse> {
    const culture = this.translateService.currentLang;
    const url = `${this.apiUrl}/${culture}/useraccount/createuser`;
    return this.factoryhelperService.post<{ Result: createUserResponse}>(url, reqObj).pipe(map(x => x.Result));
  }

}
